<template>
  <div class="big-map-box">    
<!--    <div class="map-title">{{ title }}</div>-->
    <div class="map-content" id="lineMap"></div>
    <div class="map-darkcorner"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Linemap',
  props: {
    title: {
      type: String,
      default: ''
    },
    lineData: {
      type: Array
    },
    legendConf: {
      type: Array
    },
    legendColor: {
      type: Array
    }
  },
  data() {
    return {
      map: null,
      layer1: null,
      layer2: null,
      layer3: null,
      layer4: null,
      layer5: null
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.map = new AMap.Map('lineMap', {
        mapStyle: 'amap://styles/b5500447492ee5d38f79824b6e68aec4',
        zoom: 10
        // features: ["bg", "road"]
      })
      this.initLayer()
    },
    initLayer() {
      let lvList = [[], [], [], [], []]
      for (let i = 0; i < this.lineData.length; i++) {
        if (this.lineData[i].hot >= this.legendConf[0].min) {
          lvList[0].push(this.lineData[i])
        } else if (this.lineData[i].hot >= this.legendConf[1].min) {
          lvList[1].push(this.lineData[i])
        } else if (this.lineData[i].hot >= this.legendConf[2].min) {
          lvList[2].push(this.lineData[i])
        } else if (this.lineData[i].hot >= this.legendConf[3].min) {
          lvList[3].push(this.lineData[i])
        } else if (this.lineData[i].hot >= this.legendConf[4].min) {
          lvList[4].push(this.lineData[i])
        }
      }

      for (let i = 0; i < lvList.length; i++) {
        this['layer' + (i + 1)] = new Loca.LineLayer({
          map: this.map,
          fitView: true
        })
        this['layer' + (i + 1)]
          .setData(lvList[i], {
            lnglat: 'line'
          })
          .setOptions({
            style: {
              borderWidth: 1.6 * (lvList.length - (i + 1)) + 2,
              opacity: 0.8,
              shadowColor: this.legendColor[i],
              shadowBlur: 20,
              color: this.legendColor[i]
            }
          })
          .render()
      }
    }
  }
}
</script>

<style scoped lang="less"></style>
